export default "__VITE_ASSET__Clg4MVUX__"